import axios from "axios";

export default {
    async saveSubscription(userId: number | string, endpoint: string, p256dh: string, auth: string) {
        const data = new FormData();
        data.append("users_push_subs_user_id", String(userId));
        data.append("users_push_subs_endpoint", endpoint);
        data.append("users_push_subs_p256dh_key", p256dh);
        data.append("users_push_subs_auth_key", auth);
        data.append("users_push_subs_active", "1");

        const response = await axios.post(`rest/v1/create/users_push_subs`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });

        return response;
    },
};


